import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import FilterIcon from "../../../../DefaultStyles/FilterIcon";
import Flex from "../../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import Search from "../../../../Filters/Search";
import { PartyInfoFilterContainer } from "../../../Party/PartyInfo/PartyInfoFilter";
import { getSubscriptionOptionList } from "../../../../../AdminApi/commFunc";
import { useRecoilValue } from "recoil";
import { validCheckSubsIdState } from "../../../../../pages/Manage/LoginCheck";
import AlertModal from "../../../../Modal/AlertModal";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

interface ReportPartyListFilterProps {
  resetPage: () => void;
  resetSearchValue: boolean;
  setFilter: Dispatch<SetStateAction<{ value: string; type: string }>>;
  setSearch: Dispatch<
    SetStateAction<{ value: string | undefined; type: string }>
  >;
  selectedReportId: (number | null)[];
  refreshEvent: () => void;
}

export default function ReportPartyListFilter({
  resetPage,
  resetSearchValue,
  setFilter,
  setSearch,
  selectedReportId,
  refreshEvent,
}: ReportPartyListFilterProps) {
  const validCheckSubsId = useRecoilValue(validCheckSubsIdState);

  const selectedList = selectedReportId?.filter((d) => typeof d === "number");
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [searchDropdownValue, setSearchDropdownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [filterType, setFilterType] = useState<OptionType>({
    value: validCheckSubsId > 0 ? "subscription" : "",
    label: validCheckSubsId > 0 ? "Subscription" : "구분",
  });
  const [dropdownValue, setDropdownValue] = useState<OptionType>({
    value: validCheckSubsId > 0 ? `${validCheckSubsId}` : "",
    label:
      validCheckSubsId > 0
        ? `${validCheckSubsId}_${getSubsNameBySubsId3(validCheckSubsId)}`
        : "전체",
  });
  const [seletctedDeleteAskModal, setSeletctedDeleteAskModal] = useState(false);
  const [deleteSelectedRow, setDeleteSelectedRow] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: deleteSelectedRow ? `temp-account/delErrParty/all` : undefined,
    data: {
      id: selectedList,
    },
  });

  const searchDropdownOption = [
    { value: "partyid", label: "PID" }, // 검색 타입
    { value: "uid", label: "파티장 UID" },
  ];

  const filterDropdownOption = [
    { value: "subscription", label: "Subscription" }, // 필터 타입
    { value: "check", label: "유효성 체크 구분" },
  ];

  const subsList = getSubscriptionOptionList(undefined, true);

  const checkList = [
    { value: "login", label: "로그인 체크 실패" }, // 유효성 체크 리스트
    { value: "membership", label: "이용권 체크 실패" },
  ];

  useEffect(() => {
    if (response?.status === 201) {
      toast.success(
        `선택된 신고 파티 중 ${
          response?.data.count ?? 0
        }개를 리스트에서 삭제했습니다.`
      );

      refreshEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error?.data) {
      toast.error(
        error?.data ?? "선택된 신고 파티 리스트를 삭제하는 데에 실패하였습니다."
      );
    }
  }, [error]);

  useEffect(() => {}, [resetSearchValue]);

  useEffect(() => {
    if (searchValue !== "") {
      setSearch({
        value: searchValue!,
        type: searchDropdownValue?.value!,
      });
    }
  }, [searchValue]);

  return (
    <PartyInfoFilterContainer maxWidth={1350}>
      <Flex gapSize={10}>
        <DropDown
          optionList={searchDropdownOption}
          dropdownValue={searchDropdownValue}
          setDropDownValue={setSearchDropdownValue}
          boxWidth={140}
        />

        <Search
          inputType="number"
          placeholder={`${
            searchDropdownValue?.value === "partyid"
              ? "PID "
              : searchDropdownValue?.value === "uid"
              ? "파티장 UID "
              : ""
          }입력`}
          setSearchValue={setSearchValue}
          pageResetEvent={() => resetPage()}
          isResetValue={resetSearchValue}
          isDisabled={searchDropdownValue?.value === ""}
        />

        <LineBtn
          btnText="선택 삭제"
          btnHeight={38}
          disabled={!(selectedList?.length > 0)}
          btnClickEvent={() => setSeletctedDeleteAskModal(true)}
        />
      </Flex>

      <Flex gapSize={10}>
        <FilterIcon maxWidth={1350} />

        <DropDown
          optionList={filterDropdownOption}
          dropdownValue={filterType}
          setDropDownValue={setFilterType}
          boxWidth={150}
        />

        <DropDown
          isDisabled={filterType?.value === ""}
          optionList={
            filterType?.value === "subscription" ? subsList : checkList
          }
          dropdownValue={dropdownValue}
          setDropDownValue={setDropdownValue}
        />

        <ConfirmBtn
          btnColor="mint"
          btnText="적용"
          btnHeight={38}
          btnClickEvent={() => {
            setFilter({
              type: filterType?.value!,
              value: dropdownValue?.value!,
            });
          }}
          isDisabled={dropdownValue?.value === ""}
        />

        <LineBtn
          icon="refresh"
          btnText="초기화"
          btnColor="mint"
          btnHeight={38}
          disabled={dropdownValue?.value === ""}
          btnClickEvent={() => {
            setFilterType({
              value: "",
              label: "구분",
            });
            setDropdownValue({
              value: "",
              label: "전체",
            });
            setFilter({
              type: "subscription",
              value: `0`,
            });
          }}
        />
      </Flex>

      {seletctedDeleteAskModal && (
        <AlertModal
          title={`선택된 신고 파티를 리스트에서 삭제합니다.
        계속 하시겠습니까?`}
          cancelEvent={() => setSeletctedDeleteAskModal(false)}
          confirmEvent={() => {
            setDeleteSelectedRow(true);
            setSeletctedDeleteAskModal(false);
          }}
        />
      )}

      {loading && <Loader />}
    </PartyInfoFilterContainer>
  );
}
